import client from './client';
import {
  OrderFunnelAnalytics,
  OrderFunnelAnalyticsQuery,
  OrderFunnelEventPayload,
} from '../types';

const STORAGE_KEY_PREFIX = 'order_funnel_session';
const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
const apiBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;

const createSessionId = () => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

export const getOrderFunnelSessionId = (scope: string) => {
  if (typeof window === 'undefined') {
    return createSessionId();
  }

  const storageKey = `${STORAGE_KEY_PREFIX}:${scope}`;
  const existing = window.localStorage.getItem(storageKey);
  if (existing) {
    return existing;
  }

  const next = createSessionId();
  window.localStorage.setItem(storageKey, next);
  return next;
};

export const resetOrderFunnelSessionId = (scope: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(`${STORAGE_KEY_PREFIX}:${scope}`);
};

export const getStoreEntryFunnelScope = (storeIdentifier: string) =>
  `${storeIdentifier}:store-entry`;

export const trackOrderFunnelEvent = async (
  payload: OrderFunnelEventPayload,
) => {
  await client.post('order-funnel/events', payload);
};

export const getOrderFunnelAnalytics = async (
  query?: OrderFunnelAnalyticsQuery,
): Promise<OrderFunnelAnalytics> => {
  const response = await client.get('order-funnel/analytics', {
    params: query,
  });

  return response.data;
};

export const sendOrderFunnelBeacon = (payload: OrderFunnelEventPayload) => {
  if (typeof navigator === 'undefined' || !navigator.sendBeacon) {
    void trackOrderFunnelEvent(payload).catch(() => undefined);
    return;
  }

  const blob = new Blob([JSON.stringify(payload)], {
    type: 'application/json',
  });
  navigator.sendBeacon(`${apiBaseUrl}order-funnel/events`, blob);
};
